/**
 * Completion banner shown when initialization reaches 100%.
 */

import React from "react";

import { Box, Typography, Fade, alpha, useTheme } from "@mui/material";

interface LoadingCompletionBannerProps {
  visible: boolean;
  isGateBlocked: boolean;
}

export const LoadingCompletionBanner: React.FC<
  LoadingCompletionBannerProps
> = ({ visible, isGateBlocked }) => {
  const theme = useTheme();

  if (!visible) {
    return null;
  }

  return (
    <Fade in={true}>
      <Box
        sx={{
          mt: 2,
          p: 2,
          bgcolor: alpha(theme.palette.success.main, 0.1),
          borderRadius: 2,
          textAlign: "center",
          border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.success.main,
            fontWeight: 500,
          }}
        >
          ✓ Initialization complete
        </Typography>
        {isGateBlocked && (
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.text.secondary,
              display: "block",
              mt: 0.5,
            }}
          >
            Ready to proceed
          </Typography>
        )}
      </Box>
    </Fade>
  );
};

export default LoadingCompletionBanner;
